import React from "react"
import Card from "./card"
import { priceSpiderRebind, lazyLoadPriceSpider } from "../services/util"

import * as styles from "../styles/scss/components/productsUsed.module.scss"

// Inline "Products used in this post" block. Rendered mid-content from a
// DatoCMS_ProductsUsedRecord modular block (see pageContents.js). Mirrors the
// rated-card + PriceSpider behaviour of featuredProducts.js, but for an
// editor-curated set of products placed within the article body.
const ProductsUsed = ({
    title,
    products = [],
    reviews = [],
}) => {
    // Attach BazaarVoice review stats the same way featuredProducts does, so the
    // rated cards show star ratings. reviews covers all products (built in
    // gatsby-node.js and passed via pageContext), not just relatedProducts.
    const enrichedProducts = React.useMemo(() => {
        if (!Array.isArray(products)) return []
        return products
            .filter(product => product && product.slug)
            .map(product => {
                if (Array.isArray(reviews) && product.bazaarVoiceId) {
                    const review = reviews.find(e => e.id === product.bazaarVoiceId)
                    if (review) {
                        return { ...product, reviewStats: review }
                    }
                }
                return product
            })
    }, [products, reviews])

    React.useEffect(() => {
        priceSpiderRebind()
    })

    React.useEffect(() => {
        lazyLoadPriceSpider()
    }, [])

    if (enrichedProducts.length === 0) {
        return null
    }

    return (
        <div className={styles.ProductsUsedContainer}>
            <h2 className={styles.Heading}>
                {title || "Products used in this post"}
            </h2>
            <div className={styles.Grid}>
                {enrichedProducts.map((product, idx) => (
                    <div key={product.id || idx} className={styles.GridItem}>
                        <Card
                            type="ratedProduct"
                            title={product.displayName}
                            image={product.listImage ? product.listImage.url : ""}
                            product={product}
                            slug={product.slug}
                            alternativeLook
                        >
                            {product.teaser && <p>{product.teaser}</p>}
                        </Card>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default React.memo(ProductsUsed)
